module.exports = __webpack_public_path__ + "media/images/flags/64/Norfolk-Island-ff3b5ccba8ca68657c47dad939972b39.png";